import React, { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { titles } from '@om/redux/actions/kaMetlhaFuneralCover/types';
import {
    OmApplicationCoverCategories,
    OmApplicationCoverCategoryCard,
    OmApplicationPopupModal,
    OmApplicationTooltip,
    OmButton,
    OmCheckBox,
    OmEfpFamilyMemberCardGroup,
    OmEfpQuotePage,
    OmIcon,
    OmModalLoader,
} from '@om/component-library-react';
import BwQuoteSummaryCard from './BwQuoteSummaryCard';
import './BwQuotePage.scss';
import { KMF_COVER_CATEGORIES } from '@om/redux/actions/kaMetlhaFuneralCover/types';
import {
    editQuote,
    removeMember,
    setQuoteDetailsStateValue,
    setQuoteDrawerValue,
    synchFormValue,
} from '@om/redux/actions/kaMetlhaFuneralCover/quote';
import {
    getIsOnInitPage,
    getLivesCovered,
    getMaxCountOfAllmembers,
    getMaxCountOfAllmembersQuote,
} from '@om/redux/selectors/kaMetlhaFuneralCover/quote';
import { createStructuredSelector } from 'reselect';
import QuoteModals from '../quoteModals/QuoteModals';
import KmfFamilyMemberCard from './KmfFamilyMemberCard';
import BenefitsCard from './BenefitsCard';
import ApplicationTooltip from '../../../../components/applications/ApplicationTooltip';
import { quoteService } from '@om/redux/middleware/services/kaMetlhaFuneralCover/quoteService';
import { getPolicyQuote } from '@om/redux/actions/kaMetlhaFuneralCover/policyRequest';
import { API_CALL_STATUS } from '@om/redux/reducers/status';
import { setKmfApiDetails } from '@om/redux/actions/kaMetlhaFuneralCover/referenceData';
import { getApiDetails, isAgentCodeLoading } from '@om/redux/selectors/kaMetlhaFuneralCover/referenceData';

const InitCoverView = () => {
    const dispatch = useDispatch();
    return (
        <div className="is-init-page">
            <div class="center">
                <h4 className="no-bottom-margin">
                    Get a quote and <strong>buy online now!</strong>
                </h4>
                <p>Choose who you would like to cover and see how much it will cost.</p>
            </div>
            <p className="center large-margin-bottom">
                <strong>Did you know?</strong> You can cover up to 17 loved ones, including parents and extended family
                members.
            </p>
            <OmApplicationCoverCategories>
                <OmApplicationCoverCategoryCard slot="first">
                    <OmIcon
                        slot="icon"
                        imageUrl="https://eu-images.contentstack.com/v3/assets/blt0554f48052bb4620/blt0f93690bb13df2a7/5f61ddd6046a1b546bb1592a/direct-family-gradient.svg"
                    />
                    <span  slot="title">Myself</span>
                    <div style={{height:'125px'}} slot='description'><strong>Myself</strong> - This package allows you to cover Yourself . You can also  add your Parents or Extended Family</div>
                    <span slot="button">
                        <OmButton
                            text="Select Cover"
                            type="secondary"
                            size="small"
                            onClick={() => {
                                dispatch(
                                    setQuoteDrawerValue({ fieldType: 'coverType', value: KMF_COVER_CATEGORIES.MYSELF })
                                );
                            }}
                            // disabled={!tooglePrivacyNotice}
                        />
                    </span>
                    
                </OmApplicationCoverCategoryCard>
                <OmApplicationCoverCategoryCard slot="second">
                    <OmIcon
                        slot="icon"
                        imageUrl="https://eu-images.contentstack.com/v3/assets/blt0554f48052bb4620/blteaa4e52be1a62cee/5f61ddd625f7a73d06685672/extended-family-gradient.svg"
                    />
                    <span slot="title">Me and My Direct Family</span>
                    <div style={{height:'125px'}} slot='description'><strong>Me & My Direct Family</strong> - This package allows you to cover Yourself, Spouse/Partner and Children.  You can also add your Parents or Extended Family</div>
                    <span slot="button">
                        <OmButton
                            text="Select Cover"
                            type="secondary"
                            size="small"
                            onClick={() => {
                                dispatch(
                                    setQuoteDrawerValue({
                                        fieldType: 'coverType',
                                        value: KMF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY,
                                    })
                                );
                            }}
                            // disabled={!tooglePrivacyNotice}
                        />
                    </span>
                    {/* <ApplicationTooltip
                        iconName="information_outline"
                        tooltipContent="By adjusting the slider, <strong>you are updating the cover amount for every member</strong> in the Me & My Direct Family cover category."
                    /> */}
                </OmApplicationCoverCategoryCard>
                
            </OmApplicationCoverCategories>
            
            {/* <OmApplicationTooltip borderLeft="false" small>
                <div className="icon-rectangle" slot="icon">
                    <OmIcon icon-name="help_outline"></OmIcon>
                </div>
                <div slot="tooltip-content" className="h6-light">
                    <strong>My Self</strong> Covered members are Myself, Parents & Parent In-Laws, Extended Family{' '}
                    <br /> <hr></hr>
                    <strong>Me & My Direct Family</strong> Covered members are Myself, Spouse/Partner, Child, Parents &
                    Parent In-Laws, Extended Family
                </div>
            </OmApplicationTooltip> */}
        </div>
    );
};

const MoreCoverView = () => {
    const dispatch = useDispatch();
    const {
        livesCovered,
        maxCountCoverMembers,
        allMembersCount,
        apiDetails:{status:purchaseApiStatus},
        agentCodeLoader,
    } = useSelector(
        createStructuredSelector({
            livesCovered: getLivesCovered,
            maxCountCoverMembers: getMaxCountOfAllmembersQuote,
            allMembersCount:getMaxCountOfAllmembers,
            apiDetails: getApiDetails,
            agentCodeLoader:isAgentCodeLoading
        })
    );
    const {
        [KMF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY]: meAndMyDirectfamily,
        [KMF_COVER_CATEGORIES.EXTENDED_FAMILY]: extendedFamily,
        [KMF_COVER_CATEGORIES.BENIFITS]: benefits,
        [KMF_COVER_CATEGORIES.PARENTS_AND_IN_LAWS]: parentsinLaws,
    } = livesCovered;
    useEffect(()=>{
        if(allMembersCount>0){
            dispatch(getPolicyQuote())
        }
    },[livesCovered])
    return (
        <div>
            <div className="is-not-init-page">
                <div className="family-member-card-group-wrapper">
                    <div className="quote-heading-wrapper">
                        <h4 className="light no-top-margin">Here's how much it will cost</h4>
                    </div>

                    <OmEfpFamilyMemberCardGroup
                        headingText={
                            titles[
                                Object.values(meAndMyDirectfamily)?.length === 1 ? 'Myself' : 'Me_and_My_Direct_Family'
                            ]
                        }
                    >
                        <div slot="family-member-card-items">
                            <KmfFamilyMemberCard
                                key={'MnD'}
                                id={'Myslef'}
                                relationship={
                                    Object.values(meAndMyDirectfamily)?.length > 1 ? 'Me & My Family' : 'Myself'
                                }
                                age={Object.values(meAndMyDirectfamily)[0]?.age.value ?? '-'}
                                coverAmount={Object.values(meAndMyDirectfamily)[0]?.coverAmount.value ?? '-'}
                                monthlyPremium={Object.values(meAndMyDirectfamily)[0]?.monthlyPremium.value}
                                category={KMF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY}
                                onDelete={() => {
                                    dispatch(
                                        removeMember({
                                            id: Object.keys(meAndMyDirectfamily)[0],
                                            category: KMF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY,
                                        })
                                    );
                                }}
                                onEdit={() =>
                                    dispatch(
                                        editQuote({
                                            id: Object.keys(meAndMyDirectfamily)[0],
                                            category: KMF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY,
                                            coverType:
                                                Object.values(meAndMyDirectfamily)?.length > 1
                                                    ? KMF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY
                                                    : KMF_COVER_CATEGORIES.MYSELF,
                                        })
                                    )
                                }
                            />
                        </div>
                    </OmEfpFamilyMemberCardGroup>
                    {Object.keys(parentsinLaws).length > 0 && (
                        <OmEfpFamilyMemberCardGroup headingText={titles.My_Parents_and_In_laws}>
                            <div slot="family-member-card-items">
                                {Object.keys(parentsinLaws)?.map((relation, keyIndex) => {
                                    const { age, coverAmount, monthlyPremium, relationship } = parentsinLaws[relation];
                                    return (
                                        <KmfFamilyMemberCard
                                            key={keyIndex}
                                            id={relation}
                                            relationship={relationship.value}
                                            age={age.value ?? '-'}
                                            deleteEnabled
                                            coverAmount={coverAmount.value ?? '-'}
                                            monthlyPremium={monthlyPremium.value}
                                            category={KMF_COVER_CATEGORIES.PARENTS_AND_IN_LAWS}
                                            // onDelete={() => dispatch(removeMember({ id: relation, category }))}
                                            onDelete={() =>
                                                dispatch(
                                                    setQuoteDetailsStateValue({
                                                        fieldType: 'deleteQuoteDetails',
                                                        value: {
                                                            id: relation,
                                                            category: KMF_COVER_CATEGORIES.PARENTS_AND_IN_LAWS,
                                                            message: `Are you sure you want to remove ${
                                                                relation?.split('_')[0]
                                                            }?`,
                                                        },
                                                    })
                                                )
                                            }
                                            onEdit={() =>
                                                dispatch(
                                                    editQuote({
                                                        id: relation,
                                                        category: KMF_COVER_CATEGORIES.PARENTS_AND_IN_LAWS,
                                                        coverType: KMF_COVER_CATEGORIES.LIVES_COVERED_SIDE_DRAWER,
                                                    })
                                                )
                                            }
                                        />
                                    );
                                })}
                            </div>
                        </OmEfpFamilyMemberCardGroup>
                    )}
                    {Object.keys(extendedFamily).length > 0 && (
                        <OmEfpFamilyMemberCardGroup headingText={titles.My_Extended_Family}>
                            <div slot="family-member-card-items">
                                {Object.keys(extendedFamily)?.map((relation, keyIndex) => {
                                    const { age, coverAmount, monthlyPremium, relationship } = extendedFamily[relation];
                                     const filteredAge=`${age.value }`.split(".")                                     
                                                const memmberAge= filteredAge.length>1?`${filteredAge[1]} months`:filteredAge[0]
                                    return (
                                        <KmfFamilyMemberCard
                                            key={keyIndex}
                                            id={relation}
                                            relationship={relationship.value}
                                            age={memmberAge ?? '-'}
                                            deleteEnabled
                                            coverAmount={coverAmount.value ?? '-'}
                                            monthlyPremium={monthlyPremium.value}
                                            category={KMF_COVER_CATEGORIES.EXTENDED_FAMILY}
                                            // onDelete={() => dispatch(removeMember({ id: relation, category }))}
                                            onDelete={() =>
                                                dispatch(
                                                    setQuoteDetailsStateValue({
                                                        fieldType: 'deleteQuoteDetails',
                                                        value: {
                                                            id: relation,
                                                            category: KMF_COVER_CATEGORIES.EXTENDED_FAMILY,
                                                            message: `Are you sure you want to remove ${
                                                                relation?.split('_')[0]
                                                            }?`,
                                                        },
                                                    })
                                                )
                                            }
                                            onEdit={() =>
                                                dispatch(
                                                    editQuote({
                                                        id: relation,
                                                        category: KMF_COVER_CATEGORIES.EXTENDED_FAMILY,
                                                        coverType: KMF_COVER_CATEGORIES.LIVES_COVERED_SIDE_DRAWER,
                                                    })
                                                )
                                            }
                                        />
                                    );
                                })}
                            </div>
                        </OmEfpFamilyMemberCardGroup>
                    )}
                </div>
            </div>

            {maxCountCoverMembers !== 10 && (
                <div className="add-more-cover-wrapper">
                    <h5 className="medium">Would you like to cover more people?</h5>
                    <div className="button-wrapper">
                        <OmButton
                            text="ADD MEMBER +"
                            type="secondary"
                            size="small"
                            // actionType={addedMaxCoverMembers}
                            onClick={() => {
                                dispatch(
                                    setQuoteDrawerValue({
                                        fieldType: 'coverType',
                                        value: KMF_COVER_CATEGORIES.LIVES_COVERED_SIDE_DRAWER,
                                    })
                                );
                            }}
                        />
                    </div>
                </div>
            )}
            <div className="family-member-card-group-wrapper">
                {Object.keys(benefits).length > 0 && (
                    <OmEfpFamilyMemberCardGroup headingText={"You've added these benefits"}>
                        <div slot="family-member-card-items">
                            <BenefitsCard
                                key={'benefits'}
                                id={'benefits'}
                                deleteEnabled
                                premiumPaidUp={Object.values(benefits)[0]?.benefitsDetailsOnPremium?.value}
                                cashback={Object.values(benefits)[0]?.benefitsDetails?.value}
                                onDelete={() =>
                                    dispatch(
                                        setQuoteDetailsStateValue({
                                            fieldType: 'deleteQuoteDetails',
                                            value: {
                                                id: Object.keys(benefits)[0],
                                                category: KMF_COVER_CATEGORIES.BENIFITS,
                                                message: `Are you sure you want to remove benefits?`,
                                            },
                                        })
                                    )
                                }
                                onEdit={() =>
                                    dispatch(
                                        editQuote({
                                            id: Object.keys(benefits)[0],
                                            category: KMF_COVER_CATEGORIES.BENIFITS,
                                            coverType: KMF_COVER_CATEGORIES.BENIFITS,
                                        })
                                    )
                                }
                            />
                        </div>
                    </OmEfpFamilyMemberCardGroup>
                )}
            </div>
            {Object.values(livesCovered[KMF_COVER_CATEGORIES.BENIFITS]).length === 0 && (
                <div className="add-more-cover-wrapper FuneralBenefitSummary">
                    <h5 className="medium">Would you like to add more benefits to your cover?</h5>
                    <div className="button-wrapper">
                        <OmButton
                            text="ADD BENEFITS +"
                            type="secondary"
                            size="small"
                            // actionType={addedMaxCoverMembers}
                            onClick={() => {
                                dispatch(synchFormValue(KMF_COVER_CATEGORIES.BENIFITS));
                                dispatch(
                                    setQuoteDrawerValue({
                                        fieldType: 'coverType',
                                        value: KMF_COVER_CATEGORIES.BENIFITS,
                                    })
                                );
                            }}
                        />
                    </div>
                </div>
            )}
            <OmModalLoader
                slot="loading-modal"
                loaderText={agentCodeLoader ?"Get AgentCode..." : "Get Quote..."}
                verticalAlignMiddle="true"
                open={purchaseApiStatus === API_CALL_STATUS.PENDING}
            />
            <OmApplicationPopupModal
                slot="error-modal"
                name="ErrorResponseModal"
                exitable={false}
                open={purchaseApiStatus === API_CALL_STATUS.FAILURE}
            >
                <div slot="content">
                    <OmIcon imageUrl="https://eu-images.contentstack.com/v3/assets/blt0554f48052bb4620/blt94f2cb596218bd62/5f2935c8ee8504335e705005/WRONG_CMOS.svg" />
                    <h5 className="no-bottom-margin">Something Went Wrong</h5>
                    <h6 className="no-bottom-margin account-verification-text">Please try again later</h6>
                </div>
                <OmButton
                    slot="button"
                    type="primary"
                    size="large"
                    text="Try again"
                    onClick={() => dispatch(setKmfApiDetails({status:API_CALL_STATUS.IDLE,name:'purchaseService'}))}
                />
            </OmApplicationPopupModal>
        </div>
    );
};

const BwQuotePage = ({ slot }) => {
    const dispatch = useDispatch();
    const [tooglePrivacyNotice, setTooglePrivacyNotice] = useState(false);
    const { isOnInitPage } = useSelector(
        createStructuredSelector({
            isOnInitPage: getIsOnInitPage,
        })
    );

    // useEffect(() => {
    //     if (createQuoteSuccess) {
    //         dispatch(membersUpdatedLivesCovered());
    //         dispatch(navigateIndex(PAGE_INDICES.REPLACEMENT_POLICY));
    //         dispatch(sendQuoteCreateCancel());
    //         navigate('/ka-metlha-funeral-cover/replacement-policy');
    //     }
    // }, [createQuoteSuccess, activePageIndex, dispatch]);

    // useSessionCamVariables(requestId);
    return (
        <>
            <OmEfpQuotePage slot={slot} className={'efp-quote-page'}>
                <div slot="side-drawers">
                    <QuoteModals />
                </div>

                <div slot="quote-page">
                    {isOnInitPage ? <InitCoverView /> : <MoreCoverView />}

                    <OmModalLoader verticalAlignMiddle loaderText="Submitting your quote" open={false} />
                </div>
                {/* <div slot="quote-page">
                    <div
                        className="check-box-container"
                        id="declarationquote"
                        style={{ textAlign: 'center', marginTop: '2rem' }}
                    >
                        <OmCheckBox
                            checked={tooglePrivacyNotice}
                            onOnCheckBoxChanged={() => setTooglePrivacyNotice((val) => !val)}
                        >
                            <p slot="text-slot">
                                I accept Old Mutual's&nbsp;
                                <a
                                    href="/about-old-mutual/privacy-policy/"
                                    style={{ color: '#282828', textDecoration: 'underline', fontWeight: 'normal' }}
                                    target="_blank"
                                >
                                    terms and conditions
                                </a>
                            </p>
                        </OmCheckBox>
                    </div>
                </div> */}
                <div slot="quote-summary-card" className='greyCheckbox'>
                    {!isOnInitPage &&(<div
                        className="check-box-container"
                        id="declarationquote"
                        style={{ textAlign: 'center', marginTop: '2rem' }}
                    >
                        <h5 className="medium">Before proceeding, please accept the terms & conditions and privacy policy.</h5>
                        <OmCheckBox
                            checked={tooglePrivacyNotice}
                            onOnCheckBoxChanged={() => setTooglePrivacyNotice((val) => !val)}
                        >
                            <p slot="text-slot">
                                I accept Old Mutual's&nbsp;
                                <a
                                    href="/about-old-mutual/disclaimer/"
                                    style={{ color: '#282828', textDecoration: 'underline', fontWeight: 'normal' }}
                                    target="_blank"
                                >
                                    terms and conditions  
                                </a>
                                &nbsp; and I have read the &nbsp; 
                                <a
                                    href="/about-old-mutual/privacy-policy/"
                                    style={{ color: '#282828', textDecoration: 'underline', fontWeight: 'normal' }}
                                    target="_blank"
                                >
                                    privacy notice 
                                </a>
                            </p>
                        </OmCheckBox>
                        
                    </div>)}
                    <div>{!isOnInitPage && <BwQuoteSummaryCard name="quote-card" isBuyNowDisabled={tooglePrivacyNotice}/>}</div>
                </div>
                <div slot="quote-summary-card-sticky">
                    <div>{!isOnInitPage && <BwQuoteSummaryCard isSticky name="quote-card-sticky" isBuyNowDisabled={tooglePrivacyNotice}/>}</div>
                </div>
            </OmEfpQuotePage>
            <div className="center large-margin-top">
                <p className="no-margin">
                    <strong>Please note, when adding a child:</strong>
                </p>
                <p className="no-margin">
                    Age limit: 21 years, unless the child is a student
                    <br />
                    If the child is a student, they can be covered until the age of 25
                    <br />
                    Special needs children are covered until the policy terminates, regardless of age <br />
                    Alternatively, you can add the child an extended family member
                </p>
            </div>
        </>
    );
};

export default BwQuotePage;
